import { Routes } from '@angular/router';

import { roleGuard } from '../../@core/authentication/guards/role.guard';
import { AccountType } from '../../@core/authentication/models/account-type.enum';
import { profileRoutes } from '../profile/profile.routes';

/**
 * CHECKER-only routes. Default landing: checker-review.
 */
export const checkerRoleRoutes: Routes = [
  {
    path: 'checker',
    canActivate: [roleGuard(AccountType.CHECKER)],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('../dashboard/dashboard-outlet').then((m) => m.DashboardOutlet),
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('../dashboard/pages/checker-review/checker-review').then(
                (m) => m.CheckerReview,
              ),
          },
          {
            path: 'checker/:batchId/:caseId',
            loadComponent: () =>
              import(
                '../dashboard/pages/checker-review/checker-review-detail/checker-review-detail'
              ).then((m) => m.CheckerReviewDetail),
          },
        ],
      },
      ...profileRoutes,
    ],
  },
];
